/* eslint-disable */

import grey from '@material-ui/core/colors/grey';
import Colors from '../../Support/Theme/Colors/Colors';

/**
 * Create styles for `<OrderCard />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<OrderCard />` styles
 */
const orderCardStyles = ({ theme }) => ({
  orderCardContainer: {
    '&:hover': {
      backgroundColor: grey[100],
    },
    padding: `${theme.spacing(1) * 2}px`,
    width: `100%`,
    [theme.breakpoints.down(`xs`)]: {
      left: `50%`,
      marginLeft: `-50vw`,
      marginRight: `-50vw`,
      position: `relative`,
      right: `50%`,
      width: `100vw`,
    },
  },
  highlight: {
    backgroundColor: Colors.boralgreen[50],
    // animation: 'fadeout-bg 2s ease-in-out 1s both',
  },
  // '@-webkit-keyframes fadeout-bg': {
  //   from: { background: `#B3E5CA` },
  //   to: { background: `#FFFFFF` },
  // },
  // '@keyframes fadeout-bg': {
  //   from: { background: `#B3E5CA` },
  //   to: { background: `#FFFFFF` },
  // },
});

export default orderCardStyles;
